import { motion } from "framer-motion";
import styled from "styled-components";
import { useState } from "react";
import { MdClose } from "react-icons/md";
import "./index.css";

const Levels = [
  { id: "Lower Ground", name: "Lower ground", office: "3,658", terrace: "" },
  { id: "Ground", name: "Ground", office: "3,941", terrace: "" },
  { id: "1", name: "First Floor", office: "6,523", terrace: "" },
  { id: "2", name: "Second Floor", office: "6,538", terrace: "" },
  { id: "3", name: "Third Floor", office: "6,533", terrace: "" },
  { id: "4", name: "Fourth Floor", office: "6,447", terrace: "" },
  { id: "5", name: "Fifth Floor", office: "6,547", terrace: "" },
  { id: "6", name: "Sixth Floor", office: "6,174", terrace: "" },
  { id: "7", name: "Seventh Floor", office: "4,818", terrace: "258" },
  { id: "8", name: "Eighth Floor", office: "3,436", terrace: "506" },
]

export default function Plates({ close }) {
  const [selectedFloorIndex, setSelectedFloorIndex] = useState(0);
  const [planType, setPlanType] = useState("plans");

  return (
    <StyledPlates
      animate={{ opacity: 1, y: 0, transition: { duration: 0.5 } }}
      initial={{ opacity: 0, y: 100 }}
      exit={{ opacity: 0, transition: { duration: 0.5 } }}
    >
      <button className="close" onClick={() => close()}>
        <MdClose />
      </button>
      <div className="plates">
        <div className="list">
          {/* <div className="wrapp1">
            <span >{Levels.slice(0).reverse()[selectedFloorIndex].name}</span>
            <span >{`Office ${Levels.slice(0).reverse()[selectedFloorIndex].office} SQ FT`}</span>
            <span >{`Terrace ${Levels.slice(0).reverse()[selectedFloorIndex].terrace} SQ FT`}</span>
          </div> */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="wrapp">
              <span style={{ width: "120px" }}>{""}</span><span style={{ width: "53px" }}>{"Office"}</span><span style={{ width: "75px" }}>{"Terrace"}</span>
            </div>
            <div className="wrapp">
              <span style={{ width: "120px" }}>{"Level"}</span><span style={{ width: "53px" }}>{"SQ FT"}</span><span style={{ width: "65px" }}>{"SQ FT"}</span>
            </div>
            {Levels.slice(0).reverse().map((level, index) => {
              return <button
                key={level.id}
                // disabled=
                onClick={() => setSelectedFloorIndex(index)}
                className={selectedFloorIndex === index && "active" || undefined}
                disabled={planType === "spaces" && index < Levels.length - 2}

              // onMouseOver={() => setSelectedFloorIndex(index)}
              // onFocus={() => setSelectedFloorIndex(index)}
              >
                <span style={{ width: "120px" }}>{level.id}</span><span style={{ width: "80px" }}>{level.office}</span><span style={{ width: "50px" }}>{level.terrace}</span>
              </button>
            })}
          </div>
        </div>
        <div className="preview">
          <img src={`/${planType}/${Levels.slice(0).reverse()[selectedFloorIndex].id}.png`} alt=" " />
          <div>
            <button
              className={planType === "plans" ? "active" : undefined}
              onClick={() => setPlanType("plans")}
            >
              FLOOR PLANS
            </button>
            {selectedFloorIndex >= Levels.length - 2 && <button
              className={planType === "spaces" ? "active" : undefined}
              onClick={() => {
                setPlanType("spaces")
                // setSelectedFloorIndex(Levels.length - 1)
              }}
            >
              SPACE PLANS
            </button>}
          </div>
        </div>
      </div>
    </StyledPlates >
  );
}



const StyledPlates = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #cdb385;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 2rem;
  @media (max-width: 900px) {
    padding: 4rem 1rem;
    flex-direction: column;
  }
  .close {
    /* height: 20%; */
    padding: 1rem;
    border-radius: 50%;
    aspect-ratio: 1;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #9c8961;
    font-size: 1.5rem;
    color: #fff;
    cursor: pointer;
    @media (max-width: 900px) {
      position: absolute;
      top: 1rem;
      right: 1rem;
      font-size: 1.2rem;
      padding: 0.5rem;
    }
  }
  .wrapp1{
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;
    justify-content: space-between !important;
    align-items: center;
    width: 98%;
    margin-bottom: 25px;
    margin-top: -40px;

    span {
      font-size: 1.5em;
      font-weight: 300;
      margin-left: 1rem;
      color: #f6f6f6;
      padding: 5px;
      letter-spacing: 5px;
      @media (max-width: 900px) {
        font-size: 0.7rem;
      }
    }
  }
  .wrapp{
    display: flex;
    justify-content: space-between !important;
    align-items: center;
    width: 98%;
    padding: 16px 3px;

    span {
      font-size: 1.2em;
      font-weight: 300;
      margin-left: 1rem;
      color: #f6f6f6;
      @media (max-width: 900px) {
        font-size: 0.7rem;
      }
    }
  }
  .plates {
    width:100%;
    flex: 1;
    padding: 2rem;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    @media (max-width: 900px) {
      padding: 0;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 0;
      height: 100%;
      overflow-y: auto;
      width: 100%;
    }
    div {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 3;
      @media (max-width: 900px) {
        flex: 1;
      }
      button {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        font-size: .9rem;
        font-weight: 300;
        background: transparent;
        border: none;
        padding: .7rem;
        text-align: left;
        color: #9c8961;
        cursor: pointer;
        @media (max-width: 900px) {
          font-size: 0.8rem;
          padding: 0.5rem;
        }
        span {
          font-size: 1.2em;
          font-weight: 300;
          margin-left: 1rem;
          color: #f6f6f6;
          @media (max-width: 900px) {
            font-size: 0.7rem;
          }
        }
        &:not(:last-child) {
          border-bottom: 1px solid rgb(255 255 255 / 38%);
        }
        &:hover,
        &:focus {
          background: #31313121;
        }
      }
    }
    .preview {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      @media (max-width: 900px) {
        width: 100%;
        justify-content: flex-start;
        margin-top: 1rem;
      }
      img {
        height: 95%;
        object-fit: contain;
        object-position: center;
        @media (max-width: 900px) {
          height: auto;
          width: 100%;
        }
      }
      div {
        margin-top: 1rem;
        display: flex;
        align-items: center;
        @media (max-width: 900px) {
          margin-top: 0;
        }
        button {
          white-space: nowrap;
          border: none;
          padding: 0.5rem;
          font-size: 1rem;
          padding: 0.5rem 1.5em;
          color: #ffffffd9;
          border-radius: 10px;
          margin-left: 13px;
          background-color: #8f7d5d;
          
          &:hover,
          &:focus {
            background: #ffffff;
            color: #313131;
          }
        }
        .active {
          background: #ffffff;
          color: #313131;
      }
      }
    }
    .list {
      flex: 1;
      min-height: 65vh;
      display: flex;
      align-items: flex-start;
      grid-template-columns: 1fr;
      @media (max-width: 900px) {
        display: flex;
        flex-wrap: wrap;
      }
      .active {
        background: #31313178;
        color: #000;
      }
    }
  }
`;
